import React from 'react';

export const Testimonial = ({ testimonialData }) => {
    return (
        <blockquote>
            <p>{testimonialData.Statement}</p>
            <footer>{testimonialData.FirstName}</footer>
        </blockquote>
    );
};